import { aplicaFiltroEmURL, removeFiltroDaURL, limparFiltrosDaURL, capturaFiltrosDaURL, renderFiltroSelect, removeAccents } from '../helpers';
import { store } from '../store';
import { api } from '~/src/services/axios';
import { salvarFiltros, recuperarFiltros, removerFiltros, removeFiltro } from '../helpers/filtroDb';
import VueTheMask from 'vue-the-mask';

export default {
  install:(app) => {
    app.config.globalProperties.$i18n = (argument)=>{
      return window.t(argument);
    };
    app.config.globalProperties.$store = store;
    app.config.globalProperties.$aplicaFiltroEmURL = aplicaFiltroEmURL;
    app.config.globalProperties.$removeFiltroDaURL = removeFiltroDaURL;
    app.config.globalProperties.$limparFiltrosDaURL = limparFiltrosDaURL;
    app.config.globalProperties.$capturaFiltrosDaURL = capturaFiltrosDaURL;
    app.config.globalProperties.$api = api;
    app.config.globalProperties.$renderFiltroSelect = renderFiltroSelect;
    app.config.globalProperties.$removeAccents = removeAccents;
    app.use(VueTheMask);
    // Adicionando as funções do filtroDb como helpers globais
    app.config.globalProperties.$filtroDb = {
      salvarFiltros,
      recuperarFiltros,
      removerFiltros,
      removeFiltro
    };
  }
};
